import { EVENT_KEY, TRACKING_ACTION, TRACKING_INTERACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'

const notificationsTracking = {
  trackNotification () {
    const action = {
      toggleUnread: ({ isFiltering }) => trackingUtils.track(EVENT_KEY.NOTIFICATION_CENTER.ACTION, { action: isFiltering ? TRACKING_ACTION.SHOW_UNREAD : TRACKING_ACTION.HIDE_UNREAD }),
      markAs: ({ read }) => trackingUtils.track(EVENT_KEY.NOTIFICATION_CENTER.ACTION, { action: read ? TRACKING_ACTION.MARK_READ : TRACKING_ACTION.MARK_UNREAD }),
      openPush: () => trackingUtils.track(EVENT_KEY.PUSH.ACTION, { action: TRACKING_INTERACTION.OPEN }),
      receivePush: () => trackingUtils.track(EVENT_KEY.PUSH.ACTION, { action: TRACKING_ACTION.RECEIVE }),
      tokenChangePush: () => trackingUtils.track(EVENT_KEY.PUSH.ACTION, { action: TRACKING_ACTION.TOKEN_CHANGE })
    }
    const interaction = {
      openItem: () => trackingUtils.track(EVENT_KEY.NOTIFICATION_CENTER.INTERACTION, { interaction: TRACKING_INTERACTION.CLICK_NOTIFICATION })
    }

    return { interaction, action }
  }
}

export default notificationsTracking
